import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;
const SYS = Global.system;

class NewsService {
    getNews() {
        let ruta = `${API_URL}/news`;
        return axios
            .get(ruta, {
                headers: headerRequest(),
            })
            .catch((error) => {
                return error;
            });
    }

    getNewsById(id) {
        const ruta = `${API_URL}/news/${id}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }

    getAllNews(id_categoria,id_excluido) {
        const ruta = `${API_URL}/news-suggested/${id_categoria}/${id_excluido}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
    
}

export default new NewsService();
